import {IconButton} from '@dropbox/dig-components/buttons';
import {Tooltip} from '@dropbox/dig-components/tooltips';
import {atoms} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {AttachLine} from '@dropbox/dig-icons/assets';
import {
  type AiSearchAttachMethod,
  attachFileKind,
  logAiSearchInteraction,
} from 'analytics/aiSearchAnalytics';
import {snackbarAtom} from 'atoms/snackbar';
import {t} from 'i18next';
import {useSetAtom} from 'jotai';
import {useCallback} from 'react';

/**
 * Attaching files to Ask isn't built yet. The button, drop, and paste all land
 * here: log the interest (with the file kind, never the name) and say so.
 */
export const useAiSearchAttachInterest = () => {
  const setSnackbar = useSetAtom(snackbarAtom);
  return useCallback(
    (method: AiSearchAttachMethod, files: File[] = []) => {
      logAiSearchInteraction({
        action: 'attach_interest',
        method,
        fileKind: files.length ? attachFileKind(files[0]) : undefined,
        fileCount: files.length,
      });
      setSnackbar({text: t('ai_search_attach_coming_soon')});
    },
    [setSnackbar]
  );
};

export const AiSearchAttachButton = ({onClick}: {onClick: () => void}) => (
  <Tooltip placement="top" title={t('ai_search_attach')}>
    <IconButton
      variant="borderless"
      size="small"
      onClick={onClick}
      aria-label={t('ai_search_attach')}
    >
      <UIIcon src={AttachLine} className={atoms({color: 'Text Subtle'})} />
    </IconButton>
  </Tooltip>
);
